export default __webpack_public_path__ + "static/media/infra-17.067be4a5.webp";